import { Tags, Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface ClassificationsEmptyProps {
  onCreateClick?: () => void
}

/**
 * ClassificationsEmpty displays empty state for classifications
 */
export function ClassificationsEmpty({
  onCreateClick,
}: ClassificationsEmptyProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="rounded-full bg-muted p-6 mb-4">
        <Tags className="h-12 w-12 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold mb-2">No classifications yet</h3>
      <p className="text-sm text-muted-foreground text-center mb-6 max-w-md">
        Create your data classification taxonomy to organize and govern data
        based on sensitivity and regulatory requirements.
      </p>
      {onCreateClick && (
        <Button onClick={onCreateClick}>
          <Plus className="mr-2 h-4 w-4" />
          Create Classification
        </Button>
      )}
    </div>
  )
}
